import React from 'react';
import { NavLink } from 'react-router-dom';

import '../assets/scss/Admin/AdminLayout.scss';

const adminNav = [
	{ to: '/admin/reguser', label: 'Registrer bruker' },
	{ to: '/admin/users', label: 'Brukere' },
	{ to: '/admin/errors', label: 'Feil' },
];

const AdminSubnav = () => (
	<nav className='admin-subnav' aria-label='Admin'>
		<ul className='admin-subnav__list'>
			{adminNav.map(({ to, label }) => (
				<li key={to}>
					<NavLink
						to={to}
						className={({ isActive }) =>
							`admin-subnav__link${isActive ? ' admin-subnav__link--active' : ''}`
						}
					>
						{label}
					</NavLink>
				</li>
			))}
		</ul>
	</nav>
);

export default AdminSubnav;
